module.exports = __webpack_public_path__ + "img/icon5.13627a07.png";